import React from 'react';
import './WhatApp.css';

const WhatApp = () => {
  return (
    <a
      href="https://wa.link/h1nmlm" 
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp_float"
    >

      <i className="fa-brands fa-whatsapp whatsapp-icon"></i>
    </a>
  );
};

export default WhatApp;
